import React from "react";
import PropTypes from 'prop-types';

import Title from "./Title";
import Content from "./Content";

import DialogActions from "components/DialogActions";

import { Dialog } from "@mui/material";

const EditModal = ({ open, value, name, onChange, onCancel, onClose, customCtaAction, file, onImageRemove, socials, onSave }) => {

  const dialogMaxWidth = name === 'title' || name === 'image' ? 'sm' : 'md';
  const isImage = name === 'logo' || name === 'cover_image';
  const isCustomCta = name === 'custom_cta';
  const disabled = !isImage && !value?.trim() || isCustomCta && !customCtaAction?.trim();
  const handleClose = name === 'social_links' ? null : () => onClose();
  
  return (
    <Dialog open={open} onClose={onCancel} maxWidth={dialogMaxWidth} fullWidth>
      <Title name={name} onCancel={onCancel} />
      <Content 
        name={name}
        value={value}
        file={file}
        socials={socials}
        customCtaAction={customCtaAction}
        onChange={onChange}
        onImageRemove={onImageRemove}
        onSave={onSave}
      />
      <DialogActions onCancel={onCancel} onClose={handleClose} disabled={disabled} cancelText="Close" />
    </Dialog>
  );
};

EditModal.propTypes = {
  open: PropTypes.bool,
  value: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  onPreview: PropTypes.func,
  customCtaAction: PropTypes.string,
  file: PropTypes.object,
  onImageRemove: PropTypes.func,
  socials: PropTypes.array,
  onSave: PropTypes.func,
}; 

export default EditModal;